import index from "../index/en.js"
import login from "../login/en.js"
import projectList from "../projectList/en.js"
import post from "../post/en.js"
import admin from "../admin/en.js"
import outputFile from "../outputFile/en.js"
import dashboard from "../dashboard/en.js"
import explan from "../explan/en.js"

export default {
  index,
  login,
  projectList,
  post,
  admin,
  outputFile,
  dashboard,
  explan
}



// WEBPACK FOOTER //
// ./src/locale/lang/en.js